import { Component, OnInit } from "@angular/core";

import { combineLatest, from, Observable, throwError } from "rxjs";
import { catchError, filter, map } from "rxjs/operators";

import { DffSimpelDialog } from "@dffedb/ui";
import { DffError } from "@dffedb/util";
import { MaalerOplysninger } from "@e-forsyning/common/maaler";
import { RedirectService } from "@e-forsyning/common/router";

import { OpgaveLocalstorageService } from "../shared/opgave.localstorage.service";
import { OpgaveService } from "../shared/opgave.service";
import { OpgaveListeItem } from "./model/opgave-liste-item.model";
import { OpgaveListeViewModel } from "./model/opgave-liste.view-model";
import { OpgaveListeSandbox } from "./opgave-liste.sandbox";
import { MatDialogConfig } from "@angular/material/dialog";

@Component({
    selector: "opgave-liste",
    templateUrl: "./opgave-liste.component.html",
    styleUrls: ["./opgave-liste.component.scss"]
})
export class OpgaveListeComponent implements OnInit {
    protected opgaver: OpgaveListeItem[];
    protected maalerOplysninger: MaalerOplysninger;
    public vm$: Observable<OpgaveListeViewModel>;
    public fejlmeddelelse = "";

    constructor(
        private readonly sandbox: OpgaveListeSandbox,
        private readonly service: OpgaveService,
        private readonly localstorageService: OpgaveLocalstorageService,
        private readonly redirectService: RedirectService,
        private readonly dffDialog: DffSimpelDialog
    ) {}

    public ngOnInit(): void {
        this.vm$ = this.sandbox.hentViewModel();

        const opgaver$ = this.service.hentOpgaver();
        const maalerOplysninger$ = this.service.hentMaalerOplysningerForAktuelInstallation();
        combineLatest([opgaver$, maalerOplysninger$])
            .pipe(
                catchError((error: any) => {
                    this.fejlmeddelelse = error.friendlyMessage || error.message;
                    return throwError(new DffError(error.message, { friendlyMessage: this.fejlmeddelelse, innerError: error }));
                })
            )
            .subscribe((data) => {
                this.opgaver = data[0];
                this.maalerOplysninger = data[1];
            });
    }

    public onStartClick(opgaveId: number): void {
        this.redirectService.redirect(`/opgaver/${opgaveId}`);
    }

    public onAnnullerClick(opgaveId: number): void {
        from(this.dffDialog.openJaNej("Ønsker du at annullere opgaven?", "Bemærk, at alle dine ændringer vil gå tabt.", { maxWidth: 350 }))
            .pipe(filter((result: boolean) => result))
            .subscribe(() => {
                this.localstorageService.sletOpgave(opgaveId);
            });
    }

    public erIgangvaerende$(opgaveId: number): Observable<boolean> {
        const opgave$ = this.localstorageService.hentOpgave(opgaveId);
        return opgave$.pipe(map((o) => !!o));
    }
}
